import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { apiRequest } from '../utils/apiHelper';
import { useBranding } from '../context/BrandingContext';
import '../styles/login.css';

function EmailVerificationHandler() {
  const [searchParams] = useSearchParams();
  const [verificationStatus, setVerificationStatus] = useState('pending'); // 'pending', 'success', 'error'
  const [message, setMessage] = useState('E-postanız doğrulanıyor, lütfen bekleyiniz...');
  
  const { branding, loading: brandingLoading } = useBranding();
  const logoSrc = branding?.logoUrl;
  const accent = branding?.colors?.accent || '#1e293b';
  const companyName = branding?.companyName || 'Sistem';

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token || token === '[object Object]') {
      setVerificationStatus('error');
      setMessage('Geçersiz doğrulama bağlantısı. Token eksik veya hatalı.');
      return;
    }

    const verifyToken = async () => {
      try {
        const response = await apiRequest(`/auth/verify-email?token=${encodeURIComponent(token)}`, { 
          method: 'GET', 
          skipAuth: true
        });

        if (response.success) {
          setVerificationStatus('success');
          setMessage(response.message || 'E-postanız başarıyla doğrulandı! Artık giriş yapabilirsiniz.');
        } else {
          setVerificationStatus('error');
          setMessage(response.message || 'E-posta doğrulaması başarısız. Bağlantı geçersiz veya süresi dolmuş olabilir.');
        }
      } catch (error) {
        console.error('Email verification error:', error);
        setVerificationStatus('error');
        let errorMessage = 'E-posta doğrulaması sırasında bir hata oluştu.';
        
        if (error.isAuthError) {
            errorMessage = 'Oturum süresi doldu. Lütfen tekrar giriş yapın.';
        } else if (error.apiError) {
            errorMessage = "Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.";
        } else if (error.message) {
            errorMessage = error.message;
        }
        setMessage(errorMessage);
      }
    };

    verifyToken();
  }, [searchParams]);

  if (brandingLoading) {
    return (
      <div className="login-page-wrapper">
        <div className="login-container shadow-sm d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
          <div className="spinner-border text-secondary" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page-wrapper">
      <div className="login-container shadow-sm" style={{ maxWidth: '500px', width: '90%' }}>
        <div className="login-form-panel w-100" style={{ borderRight: 'none', borderRadius: '24px' }}>
          
          <div className="login-mobile-header" style={{ '--accent': accent }}>
            {logoSrc ? (
              <img src={logoSrc} alt={companyName} className="login-mobile-logo" style={{ objectFit: 'contain' }} />
            ) : (
              <span className="login-mobile-name" style={{ color: accent }}>{companyName}</span>
            )}
          </div>

          <div className="login-form-inner text-center py-5">
            <div className="mb-4 d-none d-md-block">
              {logoSrc ? (
                <img src={logoSrc} alt={companyName} style={{ height: '45px', objectFit: 'contain' }} className="mb-3" />
              ) : (
                <h4 style={{ color: accent, fontWeight: 'bold' }}>{companyName}</h4>
              )}
            </div>

            {verificationStatus === 'pending' && (
              <>
                <div className="spinner-border mb-3" style={{ color: accent }} role="status"></div>
                <h4 className="login-form-title mb-2">Doğrulanıyor</h4>
                <p className="login-form-desc mb-4">{message}</p>
              </>
            )}

            {verificationStatus === 'success' && (
              <>
                <i className="fas fa-check-circle fa-4x mb-4" style={{ color: '#22c55e' }}></i>
                <h4 className="login-form-title mb-2">Doğrulama Başarılı!</h4>
                <p className="login-form-desc mb-4">{message}</p>
                <Link to="/login" className="login-btn mt-2" style={{ backgroundColor: accent, textDecoration: 'none', display: 'inline-block' }}>
                  <i className="fas fa-arrow-right me-2"></i>
                  Giriş Yapın
                </Link>
              </>
            )}

            {verificationStatus === 'error' && (
              <>
                <i className="fas fa-times-circle fa-4x mb-4" style={{ color: '#ef4444' }}></i>
                <h4 className="login-form-title mb-2">Doğrulama Başarısız</h4>
                <p className="login-form-desc mb-4">{message}</p>
                <Link to="/login" className="login-btn mt-2 mb-3" style={{ backgroundColor: accent, textDecoration: 'none', display: 'block' }}>
                  <i className="fas fa-arrow-right me-2"></i>
                  Giriş Yapın
                </Link>
                <Link to="/signup" className="login-forgot-link" style={{ color: '#64748b' }}>
                  Tekrar Kaydolmayı Deneyin
                </Link>
              </>
            )}
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailVerificationHandler;